import React from 'react';
import { Button, Radio } from 'antd';

import { SearchOutlined } from '@ant-design/icons';
import { Container, FilterOptions } from './styles';
import { BoxInput } from '../../ProductUpdate/styles';

export function Filters({
  searchTechnicalTeam,
  sortTestimonial,
  isSortLoading,
  filterHomeValues,
  setFilterHomeValues,
  searchWord,
  setSearchWord,
  clearSearch,
}) {
  return (
    <Container>
      <BoxInput style={{ width: '100%', marginBottom: 0 }}>
        <input
          style={{ width: '100%' }}
          id="search"
          type="text"
          name="search"
          placeholder="Nome"
          onChange={(event) => setSearchWord(event.target.value)}
          onKeyDown={(event) => event.key === 'Enter' && searchTechnicalTeam()}
          value={searchWord}
        />
      </BoxInput>

      <FilterOptions>
        <Radio.Group
          onChange={(event) => setFilterHomeValues(event.target.value)}
          value={filterHomeValues}
          options={[
            { value: 1, label: 'Mostrar na home' },
            { value: 2, label: 'Mostrar na home 2' },
          ]}
        />
      </FilterOptions>

      <Button
        icon={<SearchOutlined />}
        style={{ marginLeft: 20 }}
        type="primary"
        onClick={searchTechnicalTeam}
      >
        Buscar
      </Button>

      <Button
        loading={isSortLoading}
        style={{ marginLeft: 20 }}
        onClick={sortTestimonial}
      >
        Salvar ordenação
      </Button>

      <Button type="link" onClick={clearSearch}>
        Limpar Busca
      </Button>
    </Container>
  );
}
